class EficienciaFiscalAbstractService extends AbstractService

  configure: (config, injector) ->
    injector.invoke([ '$uibModal', (modal) => @modal = modal ])

    @openCreditosModal = (resolve) =>
      @modal.open({
        size: 'md'
        backdrop: 'static'
        keyboard: false
        templateUrl: @pathService.getViewUrl() + 'financeiro/view/movimentacao-creditos/modal.html'
        controller: 'creditoModalController as ctrl'
        resolve: resolve
      })

    @openTermoDeUsoModal = (resolve, callback) =>
      modalInstance = @modal.open({
        size: 'md'
        backdrop: 'static'
        keyboard: false
        templateUrl: @pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/termo-de-uso/aceiteModal.html'
        controller: 'termoDeUsoAceiteModalController as ctrl'
        resolve: resolve
      })

      resultCallback = (result) -> callback(result) if callback
      modalInstance.result.then(resultCallback, resultCallback)

    return null

  verificaRequest: (request) -> (result) =>
    if not result.success
      switch result.message
        when 'creditos_insuficientes'
          return @openCreditosModal({
            entidade: -> result.data.entidade
            valorFaltante: -> result.data.valorFaltante
            saldo: -> result.data.saldo
          })
        when 'sem_aceite'
          return @openTermoDeUsoModal({
            contrato: -> result.data.contrato
            entidade: -> result.data.entidade
            termoDeUso: -> result.data.termoDeUso
          }, (result) =>
            if result.success
              @doRequest(request.method, request.data, request.callback, request.options)
            else
              Alert.error("É necessário aceitar os termos e condições desse serviço!", "Termos e condições")
              request.callback({success: false, message: 'sem_aceite'})
          )

    request.callback(result) if request.callback

  doRequest: (method, data, callback, options) -> super(method, data, @verificaRequest({method: method, data: data, callback: callback, options: options}), options)

window.EficienciaFiscalAbstractService = EficienciaFiscalAbstractService
